import React from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

type Holding = {
  symbol: string;
  quantity: number;
  avg_price: number;
  current_price: number;
  total_spent: number;
  current_value: number;
  profit_loss: number;
  profit_loss_percentage: number;
};

type HoldingModalProps = {
  open: boolean;
  onClose: () => void;
  data: Holding[];
};

const HoldingModal: React.FC<HoldingModalProps> = ({ open, onClose, data }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6">Holdings</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Symbol</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Quantity</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Avg Price</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Current Price</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Total Spent</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Current Value</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Profit/Loss</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>P/L %</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7}>No Holdings Found</TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.symbol}</TableCell>
                    <TableCell align="right">{item.quantity}</TableCell>
                    <TableCell align="right">
                      ₹{item.avg_price?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      ₹{item.current_price?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      ₹{item.total_spent?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      ₹{item.current_value?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      ₹{item.profit_loss?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {item.profit_loss_percentage?.toFixed(2)}%
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default HoldingModal;
